var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M.617 1.96a.617.617 0 0 1-.625-.624c0-.352.274-.633.625-.633h14.555c.351 0 .625.281.625.633a.617.617 0 0 1-.625.625zm1.649 4.024a.624.624 0 0 1-.633-.625.63.63 0 0 1 .633-.632H13.57c.352 0 .625.28.625.632a.617.617 0 0 1-.625.625zm1.601 4.024a.617.617 0 0 1-.625-.625c0-.352.274-.633.625-.633h8.094a.63.63 0 0 1 .633.633.624.624 0 0 1-.633.625z"
  })));
};
export default SvgFilters;